import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../siteConfig.js";

export default function Governance() {
  return (
    <div className="container section">
      <div className="pageHero">
        <div className="pageHeroText">
          <span className="eyebrow">Governance & Compliance</span>
          <div className="pageHeroTitle">Transparent, accountable, responsible.</div>
          <p className="pageHeroSub">
            {siteConfig.companyLegalName} operates with defined responsibilities, published policies,
            and data practices proportionate to the services we provide.
          </p>
        </div>
      </div>

      <img src="/tablet_bg_8.png" alt="Governance operations" className="pageBanner" />

      <div className="grid3" style={{ marginTop: "0" }}>
        <div className="card">
          <div className="cardTitle">📋 Policy transparency</div>
          <p className="muted" style={{ fontSize: "14px", marginBottom: "12px" }}>Our Privacy Policy and Terms & Conditions are published and kept current.</p>
          <div className="inlineLinks">
            <Link to="/privacy">Privacy Policy</Link>
            <span className="dot">•</span>
            <Link to="/terms">Terms</Link>
          </div>
        </div>
        <div className="card">
          <div className="cardTitle">🔒 Data protection</div>
          <p className="muted" style={{ fontSize: "14px" }}>We collect only what we need. Data is not sold or shared beyond what is necessary to deliver the service.</p>
        </div>
        <div className="card">
          <div className="cardTitle">📬 Regulatory contact</div>
          <p className="muted" style={{ fontSize: "14px", marginBottom: "8px" }}>Formal notices and regulatory enquiries can be directed to our support email.</p>
          <a href={`mailto:${siteConfig.supportEmail}`} style={{ color: "var(--orange)", fontSize: "14px", fontWeight: "600" }}>
            {siteConfig.supportEmail}
          </a>
        </div>
      </div>

      <div className="prose" style={{ marginTop: "40px" }}>
        <h3 className="h3">Governance approach</h3>
        <ul>
          <li>Defined ownership for products, operations, and customer support processes.</li>
          <li>Documented policies reviewed and updated when material changes occur.</li>
          <li>Issue handling and escalation paths for operational or user concerns.</li>
        </ul>

        <h3 className="h3">Data protection principles</h3>
        <ul>
          <li><strong>Purpose limitation:</strong> data is processed only for defined, legitimate purposes.</li>
          <li><strong>Data minimisation:</strong> we avoid collecting data beyond what is needed.</li>
          <li><strong>Access controls:</strong> access is restricted to authorised personnel and systems.</li>
          <li><strong>Retention limits:</strong> data is kept only as long as necessary for stated purposes.</li>
        </ul>

        <h3 className="h3">Security controls</h3>
        <ul>
          <li>Authentication controls and access management for all internal systems.</li>
          <li>Monitoring and audit logging to support reliability and incident response.</li>
          <li>Vendor due diligence where third-party processors handle personal data.</li>
        </ul>

        <h3 className="h3">Policy documents</h3>
        <ul>
          <li><Link to="/privacy">Privacy Policy</Link></li>
          <li><Link to="/terms">Terms & Conditions</Link></li>
        </ul>
      </div>
    </div>
  );
}
